module.exports = __webpack_public_path__ + "media/images/flags/4x3/mkd-9432e7d9dd61acba798a848c6067551a.svg";